module.exports = __webpack_public_path__ + "static/media/preparation.43f29bdc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/categories/preparation.jpg
// module id = 136
// module chunks = 0